import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    pastRepaymentsTitle: {
        id: '_.dashboardComponents.pastRepaymentsTitle',
        defaultMessage: 'Repayment history'
    },
    totalPastRepayments: {
        id: '_.dashboardComponents.pastRepaymentsTotalRepaid',
        defaultMessage:
            "You've repaid {amountRepaid} of the {loanAmount} you borrowed."
    },
    lastRepayment: {
        id: '_.dashboardComponents.pastRepaymentsLastRepaymentInfo',
        defaultMessage: 'Your last repayment was on {lastRepaymentDate}'
    },
    pastRepaymentCta: {
        id: '_.dashboardComponents.pastRepaymentsCTA',
        defaultMessage: 'See your repayments'
    }
});
